document.addEventListener("DOMContentLoaded", () => {
  const trigger = document.querySelector("#infinite-scroll-trigger");
  const grid = document.querySelector("#product-grid");
  const nextLink = document.getElementById("NextPageLink");

  if (!trigger || !grid || !nextLink) return;

  let loading = false;
  let nextUrl = nextLink.href || null;

  const observer = new IntersectionObserver(async (entries) => {
    if (!entries[0].isIntersecting || loading || !nextUrl) return;
    loading = true;

    // opcional: mostrar un loader visual aquí (puedes crear e insertar un elemento)
    try {
      const res = await fetch(nextUrl, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, "text/html");

      // Extrae los nuevos <li class="grid__item"> del documento de la siguiente página
      const newItems = doc.querySelectorAll("#product-grid .grid__item");

      // Inserta cada item al final del UL actual
      newItems.forEach((item) => {
        // importar el nodo al documento actual
        grid.appendChild(item.cloneNode(true));
      });

      // Actualizar nextUrl buscando el NextPageLink en la página cargada
      const newNext = doc.getElementById("NextPageLink");
      if (newNext && newNext.href) {
        nextUrl = newNext.href;
        // también actualizamos el link oculto en la página actual por si es usado en otro lado
        nextLink.href = nextUrl;
      } else {
        // no hay siguiente: dejar de observar
        nextUrl = null;
        observer.disconnect();
        // opcional: esconder trigger o mostrar mensaje "no hay más productos"
        trigger.style.display = "none";
      }
    } catch (err) {
      console.error("Infinite scroll fetch error:", err);
    }

    loading = false;
  }, {
    root: null,
    rootMargin: "400px",
    threshold: 0.01
  });

  observer.observe(trigger);
});
